<template lang="html">
    <div class="camera-preview">
        <span class="camera-preview-timer">
            {{minutes}}:{{seconds}}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        minutes: {

        },
        seconds: {

        }
    }
}
</script>

